import { Link } from 'gatsby';
import React from 'react';

import '../scss/index.scss';

const SideNav = () => {
  return (
    <aside className="menu column is-2 is-narrow-mobile is-fullheight section">
      <ul className="menu-list">
        <li><Link
          //partiallyActive
          activeClassName="is-active"
          to="../wells-fargo"
        >Wells Fargo</Link></li>
      </ul>
    </aside>
  );
}


export default function SidebarLayout({ children }) {
  return (
    <>
      <section className="hero-body has-text-centered is-justify-content-center is-flex-direction-column">
        <div className="hero-body is-italic">
          <p className="title">Comapny Interviews</p>
          <p className="subtitle">More Coming Soon...</p>
        </div>
      </section>
      <section className="main-content columns is-fullheight">
        <SideNav />
        <main className='column is-10'>{children}</main>
      </section>
    </>
  );
}
